namespace TabAurous {
    export interface MarkUpRequest extends Serenity.ListRequest {
        MarkUpType?: number;
        LaborMarkUpType?: number;
        StoneMarkUpType?: number;
        MetalMarkUpType?: number;
        RateType?: number;
        AttributeId?: number;
        AttributeIds?: number[];
        MarkUpPolicyId?: number;
        ProductTypeId?: number;
        ItemTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneSizeId?: number;
        ShapeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        QualityId?: number;
        StoneColorId?: number;
        SettingId?: number;
        ProcessId?: number;
        KaratId?: number;
        MetalColorId?: number;
        Weight?: number;
        Pieces?: number;
        PurStdLabour?: number;
        SalesStdLabour?: number;
        Amount?: number;
        MinLabour?: number;
        MaxLabour?: number;
        FromDate?: string;
        ToDate?: string;
        FromWt?: number;
        ToWt?: number;
        IsCustomerItem?: boolean;
        IsSetting?: boolean;
        LaborDetails?: TabAurous.Retail.POSSalesLaborRow[];
        Discount?: number;
    }
}
